import React, { useEffect, useRef, useState } from "react";
import logo from "../../images/LogoOnlyAnimation.gif";
// import { CiMicrophoneOn } from "react-icons/ci";
import { FaArrowUp, FaMicrophoneAlt } from "react-icons/fa";
import "./Content.css";
import { useNavigate } from "react-router-dom";
import iconLogo from "../../images/iconMobile.png";
import jooLogo from "../../images/joominLogo.png";
import { motion } from "framer-motion";
import { useQuestion } from '../../context/QuestionContext';
import { clearSessionId } from "../../utils/storage";
function Content() {
  const [isChatbotActive, setIsChatbotActive] = useState(false);
  const [question, setQuestion] = useState("");
  const { setSharedQuestion } = useQuestion();

  const textareaRef = useRef(null);

  const navigate = useNavigate();
  useEffect(() => {
    let body = document.body;
    body.style.backgroundColor = "#3B1729";
    clearSessionId();
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleClickChat();
    }
  };

  const handleClickChat = () => {
    setIsChatbotActive(true);
    setSharedQuestion(question);

    setTimeout(() => {
      let body = document.body;
      body.style.backgroundColor = "#2D111F";
      navigate('/send');
    }, 500);
  };

  const handleCardClick = (e) => {
    const question = e.currentTarget.querySelector("p").textContent;
    setSharedQuestion(question);
    navigate('/send');
  }

  const handleInput = (e) => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "auto";
      textarea.style.height = `${Math.min(textarea.scrollHeight, 208)}px`; // Limit height to 208px
    }
    setQuestion(e.target.value);
  };

  return (
    <motion.div
      initial={{
        opacity: !isChatbotActive ? 0 : 1,
      }}
      animate={{
        opacity: !isChatbotActive ? 1 : 0,
        scale: !isChatbotActive ? 1 : 1.05,
        width: isChatbotActive ? "100%" : "auto",
        height: isChatbotActive ? "100vh" : "auto",
        overflow: "hidden"
      }}
      transition={{ duration: 0.8, ease: "easeInOut" }}
      className=" bg-gradient-to-b from-[#3B1729] to-[#2D111F] rounded-3xl m-4 md:m-8 lg:mb-4 flex flex-col justify-center items-center 2xl:flex-grow "
    >
      <div className="flex justify-center items-center gap-2">
        <img src={logo} className="w-24  md:w-32 " alt="" />
        <div className="h-12 w-1 bg-white mr-4"></div>
        <img className="w-32  md:w-full " src={jooLogo} alt="" />
      </div>
      <div className="flex justify-center items-center ">
        <div className="text-center">
          <h2 className="text-white font-bold text-lg md:text-2xl my-3 relative ">
            What can I help with?
          </h2>
          <div className="flex justify-center">
            <p className="text-gray-400 text-sm text-center mx-8 mb-6  md:text-lg lg:text-base  lg:w-4/6 ">
              I'm your AI assistant, ready to provide detailed information and answer your questions 
              about your treatments. Feel free to explore or ask specific questions.
            </p>
          </div>
        </div>
      </div>
      <div className="flex justify-center gap-3 lg:gap-6 px-4 flex-wrap ">
        <div className="cardWrapper hover:scale-110 transition ease-in-out" onClick={handleCardClick}>
          <div className="cardContent ">
            <img className="w-10" src={iconLogo} alt="" />
            <h5 className="mb-4 mt-3 font-bold text-sm">
              Anti glaucoma treatment
            </h5>
            <p className="text-sm md:text-lg lg:text-base" >
              what makes xolamol differ than other eye drops?
            </p>
          </div>
        </div>
        <div className="cardWrapper hover:scale-110 transition ease-in-out" onClick={handleCardClick}>
          <div className="cardContent">
            <img className="w-10" src={iconLogo} alt="" />
            <h5 className="mb-4 mt-3 font-bold text-sm ">
              Impact on ocular blood flow
            </h5>
            <p className="text-sm md:text-lg lg:text-base ">
              what it is the benefit of xolamol to be preservative free?
            </p>
          </div>
        </div>
        <div className="cardWrapper hover:scale-110 transition ease-in-out" onClick={handleCardClick}>
          <div className="cardContent">
            <img className="w-10" src={iconLogo} alt="" />
            <h5 className="mb-4 mt-3 font-bold text-sm">Product knowledge</h5>
            <p className="text-sm md:text-lg lg:text-base ">
              why to use Xolamol over alpha agonists?
            </p>
          </div>
        </div>
      </div>

      <div className="relative w-full px-6 mt-6 mb-2">
        <textarea
          ref={textareaRef}
          name="chat"
          id="chat"
          className="w-full my-4 py-4 pl-3 rounded-lg h-14 max-h-52 resize-none bg-lightPurple/20 text-grayColor placeholder-pinkColor border border-lightPurple pr-[10rem]"
          type="text"
          placeholder="Ask JOOMINEYE"
          onKeyDown={handleKeyDown}
          value={question}
          onChange={handleInput}
          style={{ scrollbarWidth: "none" }}
        ></textarea>

        <div className="flex items-center gap-2 absolute right-11 bottom-8">
          <span className="text-lightPurple text-4xl">
            <FaMicrophoneAlt />
          </span>

          <button
            onClick={handleClickChat}
            className="h-8 w-8 rounded-full bg-gradient-to-r from-lightPurple to-lightPurple2 text-black flex justify-center items-center"
          >
            <FaArrowUp />
          </button>
        </div>
      </div>
    </motion.div>
  );
}

export default Content;

{
  /* <div className="flex justify-center relative mt-6 mb-2 w-full">
        <input
          name="chat"
          id="chat"
          className="w-11/12 lg:w-full mx-4  rounded-lg p-4 bg-purpleColor/10 text-grayColor placeholder-white  border border-white  my-4"
          type="text"
          placeholder="AsK JOOMINEYE"
          onKeyDown={handleKeyDown}
          onChange={(e) => setQuestion(e.target.value)}
        />
        <div className="flex items-center gap-1 absolute right-12 lg:right-10 top-7 z-10">
          <span className="text-greenColorLight text-4xl ">
            <CiMicrophoneOn />
          </span>
          <button
            onClick={handleClickChat}
            className="h-8 w-8 rounded-full  bg-greenColorLight text-black flex justify-center items-center"
          >
            <FaArrowUp />
          </button>
        </div>
      </div> */
}
